import script from "./returnInWarehouse.vue?vue&type=script&setup=true&lang=js"
export * from "./returnInWarehouse.vue?vue&type=script&setup=true&lang=js"

import "./returnInWarehouse.vue?vue&type=style&index=0&id=1c29d322&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c29d322"]])

export default __exports__